/**
 * A small rounded tile showing the first letter of an organization or
 * project name. Stands in for a logo in the breadcrumb and its switchers.
 */
export function EntityMark({ name }: { name: string }) {
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  return (
    <span
      aria-hidden="true"
      className="bg-muted text-foreground inline-flex size-5 shrink-0 items-center justify-center rounded-[5px] border text-[11px] leading-none font-bold"
    >
      {initial}
    </span>
  );
}
